import './App.css';
import { BrowserRouter } from "react-router-dom";
import ResponsiveView from "./lib/ResponsiveView"
import AuthProvider from "./AuthProvider";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <ResponsiveView />
                    <ToastContainer
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
